import Api from '../../../../foundation/api/Api';
import Registry from '../../../global/Registry';
import Course from '../domain/aggregates/course/Course';

export default class CourseApi extends Api<Course> {

	private static instance?: CourseApi;

	public static getInstance () {
		return this.instance !== undefined ? this.instance : this.instance = new this(Registry.getInstance().courseRepository);
	}

	public async getAll () {
		return await this.getList('/api/courses');
	}

	public async save (course: Course) {
		const data = {
			name: course.getName(),
			visibility: course.getVisibility().getValue()
		};

		return this.postOne('/api/courses' + (course.hasId() ? '/' + course.getId().getValue() : ''), data);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/api/CourseApi.ts